// tool calls types

import type { BaseDataMessage } from './base-message.types';
import type { DataMessageTypeEnum } from './messages.types';
import type { TerminalAutoApproval } from './terminal-approval.types';

// todo = move this to structured schema part of the message
export type ToolCallFileMetadata = {
  codeWithSecretsPath?: string;
  codeResultPath?: string;
  intelligenceResponsePath?: string;
  filePaths?: string[];
};

export type ToolCallStructuredOutput = {
  script?: string;
  code?: string;
  result?: unknown;
  output?: unknown;
  success?: boolean;
  error?: string;
  [key: string]: unknown;
};

export type ToolCallLabels = {
  labelPresent: string;
  labelPast: string;
  labelFailed: string;
};

export const TOOL_CALL_PROGRESS_ERROR_STAGE = 'Error';

export type ToolCallProgressEvent = {
  id: string;
  stage: string;
  detail?: string;
  timestamp: number;
};

export type ToolCallAudience = 'agent-internal';

export interface ToolCallGenericMessage extends BaseDataMessage {
  type:
    | DataMessageTypeEnum.ToolCallUpdate
    | DataMessageTypeEnum.ToolCallStart
    | DataMessageTypeEnum.ToolCallComplete
    | DataMessageTypeEnum.ToolCallError;
  toolCallId: string;
  toolName: string;
  status:
    | 'started'
    | 'in-progress'
    | 'error'
    | 'completed'
    | 'result'
    | 'aborted';
  message: string;
  labelPresent?: string;
  labelPast?: string;
  error?: string;
  timestamp: number;
  icon?: string;
  input?: unknown;
  output?: unknown | ToolCallStructuredOutput;
  timing?: {
    durationMs: number;
    startedAt: string;
    completedAt: string;
  };
  fileMetadata?: ToolCallFileMetadata;
  progressEvents?: ToolCallProgressEvent[];
  audience?: ToolCallAudience;
  autoApproval?: TerminalAutoApproval;
  metadata?: {
    inputTokens?: number;
    outputTokens?: number;
    totalTokens?: number;
    model?: string;
    [key: string]: unknown;
  };
}
